import { JSX } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { MODULE_WEBHOOKS_COLUMN_ID } from "../constants";
import { WebhookIntegrationWithTimestamp } from "../types";
import ModuleWebhooksTableDropdownCell from "./DropdownCell";
import ModuleWebhooksTableEndpointCell from "./EndpointCell";
import ModuleWebhooksTableStatusCell from "./StatusCell";
import ModuleWebhooksTableTimestampCell from "./TimestampCell";

export const MODULE_WEBHOOKS_TABLE_CELLS: Record<
  MODULE_WEBHOOKS_COLUMN_ID,
  (props: TableSimpleCellProps<WebhookIntegrationWithTimestamp>) => JSX.Element
> = {
  [MODULE_WEBHOOKS_COLUMN_ID.ENDPOINT]: ModuleWebhooksTableEndpointCell,
  [MODULE_WEBHOOKS_COLUMN_ID.STATUS]: ModuleWebhooksTableStatusCell,
  [MODULE_WEBHOOKS_COLUMN_ID.CREATED_AT]: ModuleWebhooksTableTimestampCell,
  [MODULE_WEBHOOKS_COLUMN_ID.DROPDOWN]: ModuleWebhooksTableDropdownCell,
};
